/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: content-seasonvolume-editor-component.js
 *
 * Created by randysorensen on 7/25/17.
 */

'use strict';

function ContentSeasonVolumePropertiesController (_, $routeParams, $timeout, $route, ContentEditService,
												  UtilsService) {

	var self = this;

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.requiredFields = ['name', 'value'];
	self.metadataComponentsMap = {};


	//======//
	// Data //
	//======//

	var getMetadata = function () {
		// get season/volume metadata components map, only after
		// the edit data has been loaded
		return ContentEditService.getSeasonVolumeComponentsMap().then(function (componentsMap) {
			self.metadataComponentsMap = componentsMap;
		});
	};

	var getData = function () {
		return ContentEditService.getSeasonVolumeEditData().then(function () {
			self.seasonVolume = ContentEditService.seasonVolumeObject;
		});
	};

	var copyMetadataInstanceValues = function () {
		if (!self.seasonVolume.metadata) {
			self.seasonVolume.metadata = {
				properties: {}
			};
		}

		_.forEach(self.metadataComponentsMap, function (component, name) {
			var instanceValue = component.instanceData.value;

			if (instanceValue) {
				if (!self.seasonVolume.metadata.properties[name]) {
					self.seasonVolume.metadata.properties[name] = {
						// these are required by the metadata DTO
						valueOverridden: false,
						required: false,
					};
				}
				self.seasonVolume.metadata.properties[name].value = instanceValue;
			}
		});
	};

	var requiredFieldsArePopulated = function () {
		return self.requiredFields.reduce(function (accum, field) {
			return accum && UtilsService.hasData(self.seasonVolume[field]);
		}, true);
	};


	//=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		self.loadingIndicator.show = true;

		getData().then(function () {
			getMetadata().then(function () {
				if (!self.seasonVolume.id) {
					self.editorForm.$setDirty();
				}
				$timeout(function () {
					// if the above promises resolve too quickly,
					// a $timeout() is required to shut the
					// pacifier off
					self.loadingIndicator.show = false;
				});
			});
		});
	};

	self.$onDestroy = function () {
	};

	self.$postLink = function () {
		$timeout(function () {
			ContentEditService.editorForm = self.editorForm;
		});
	};


	//=========//
	// Toolbar //
	//=========//

	self.toolbarButtons = [
		{
			label: 'Save',
			enabled: function () {
				var isDirty = self.editorForm && self.editorForm.$dirty;
				return self.seasonVolume && requiredFieldsArePopulated() && isDirty;
			},
			onClick: function () {
				self.loadingIndicator.show = true;

				copyMetadataInstanceValues();

				ContentEditService.saveSeasonVolume().then(function (newSeasonVolume) {
					// update route params with ID
					var newRouteParams = {};
					newRouteParams[$routeParams.seasonId? 'seasonId': 'volumeId'] = newSeasonVolume.id;
					$route.updateParams(newRouteParams);

					// refresh custom-metadata bindings on page
                    self.seasonVolume = ContentEditService.seasonVolumeObject;
					getMetadata().then(function () {
						self.loadingIndicator.show = false;
					});
				});
			},
		},
		{
			label: 'Revert',
			enabled: function () {
				var isNew = !self.seasonVolume || !self.seasonVolume.id;
				var isDirty = self.editorForm && self.editorForm.$dirty;
				return isNew || isDirty;
			},
			onClick: function () {
				self.loadingIndicator.show = true;

				ContentEditService.revertSeasonVolume();
				self.seasonVolume = ContentEditService.seasonVolumeObject;

				// refresh custom-metadata components on page
				getMetadata().then(function () {
					self.loadingIndicator.show = false;
				});
			},
		},
		{
			label: 'Close',
			enabled: function () {
				return true;
			},
			onClick: function () {
				ContentEditService.closeSeasonVolumeEditor();
			},
		},
	];


	//================//
	// Template Logic //
	//================//

	self.isSeason = function () {
		return $routeParams.seasonId !== undefined;
	};

}

angular
	.module('prism-ui.content')
	.component('contentSeasonVolumeProperties', {
		bindings: {
		},
		controller: ContentSeasonVolumePropertiesController,
		templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/components/view/properties/content-seasonvolume-properties-template.html'
	});
